import React, { useContext, useEffect, useState } from "react";
import FormGroup from "../../../../components/common/FormGroup/FormGroup";
import CheckBox from "../../../../components/common/checkbox/Checkbox";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import { ROUTES } from "../../../../constants/Routes.js";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import isEmail from "validator/lib/isEmail";
import { API_ROUTES } from "../../../../constants/API_ROUTES.js";
import NotificationDanger from "../../../../components/common/Notification/NotificationDanger.js";
import { AuthContext } from "../../../../context/AuthContext.js";
import AuthActions from "../../../../helpers/AuthActions/AuthActions.js";
import useAuth from "../../../../hooks/useAuth.js";

const SignIn = ({ toggleForm }) => {
  // Status
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loginError, setLoginError] = useState("");

  const navigate = useNavigate();
  const { setAuthHandler } = useAuth();

  // Auth Provider
  // const { setAuthToken, set } = useContext(AuthContext);

  const validateEmail = () => {
    if (email.length < 1) {
      setEmailError("Email is required ");
      return false;
    } else if (!isEmail(email)) {
      setEmailError("Email is Invalid !");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const validatePassword = () => {
    if (password.trim().length < 1) {
      setPasswordError("Password is required ");
      return false;
    } else {
      setPasswordError("");
      return true;
    }
  };
  const loginHandler = () => {
    if (validateEmail() && validatePassword()) {
      setLoginError("");
      AuthActions.userLogin(email, password).then((response) => {
        const status = response?.status;
        const messages = response?.message;
        const data = response?.data;
        if (status === 200) {
          const bearerToken = data?.token;
          const userData = data?.user;
          const role = "cal_user";
          console.log(bearerToken, userData, role);
          setAuthHandler({ bearerToken, userData, role });
          navigate(ROUTES.CAL_LIST);
        } else if (status === 422) {
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "email") {
                setEmailError(errorMessage);
              } else if (key === "password") {
                setPasswordError(errorMessage);
              }
            }
          }
        } else if (status === 401) {
          setLoginError(messages);
        }
      });
    }
  };
  return (
    <>
      <h3 className="text-[1.5rem] 2xl:text-[2.5rem] font-poppins font-semibold leading-normal">Kalkulátor</h3>
      <h4 className="text-[1.2rem] 2xl:text-[1.5rem] font-poppins font-semibold leading-normal mb-8 2xl:mb-12">
        Bejelentkezés
      </h4>
      <FormGroup
        type={"text"}
        label={"Email cím"}
        id={"email"}
        name={"email"}
        value={email}
        error={emailError}
        onChange={(e) => setEmail(e.target.value)}
        placeHolder={`tesztelo@example.com`}
      />

      <FormGroup
        type={"password"}
        label={"Jelszó"}
        id={"password"}
        name={"password"}
        value={password}
        error={passwordError}
        onChange={(e) => setPassword(e.target.value)}
        placeHolder={`.................`}
      />
      {loginError && <NotificationDanger message={loginError} />}
      <div className="flex flex-col gap-10 md:gap-2 md:mb-0 md:flex-row">
        <div className="w-full md:w-1/2">
          <CheckBox label={"Maradjon bejelentkezve"} />
        </div>
        <div className="w-full text-start md:w-1/2 md:text-end">
          <Link to={ROUTES.CAL_LIST}>
            <p className="underline cursor-pointer">Elfelejtett jelszó</p>
          </Link>
        </div>
      </div>
      <div className="flex flex-col gap-2 mt-10 md:flex-row">
        <div className="w-full md:w-1/2">
          <ButtonOutlineFluid label={"Registráció"} onClick={toggleForm} />
        </div>
        <div className="w-full md:w-1/2">
          <ButtonFluid label={"Belépés"} onClick={loginHandler} />
        </div>
      </div>
    </>
  );
};

export default SignIn;
